import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { SatelliteData } from "../models/Satellite";

export default class SatellitesApi {

    private http: HTTPClient;
    private rootPath!: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    async getSatelliteData(type: string, external_id: string): Promise<SatelliteData> {
        const res = await this.http.get(`${this.rootPath}/tl_data`,{
            params: {
                svccode: `portal/lot_ndvi_data_stat`,
                external_id: external_id,
                idxName: type,
                out_format: `ONLY_RESPONSE`
            }
        })
        return res.data;
    }


    async getExternalId(type: string, lang: string, lot_id: number, pk_cuaa: number, username: string): Promise<string | null> {
        const res = await this.http.get(`${this.rootPath}/rest_tl_data`, {
            params: {
                svccode: `indexes_terr/get_${type}_lots`,
                date_ref: new Date(),
                force_cache: `N`,
                has_cache: `N`,
                lang: lang,
                lot_id: lot_id,
                pk_cuaa: pk_cuaa,
                username: username
            }
        })
        if(res?.data?.services[0]?.entities[0]?.external_id){
            return res.data.services[0].entities[0].external_id;

        }else{
            return null
        }
    }

    async getImage(externalId: number, image: string): Promise<string> {
        const res = await this.http.get(`${this.rootPath}/tl_data?svccode=portal/lot_ndvi_image&external_id=${externalId}&idxName=ndvi&out_format=ONLY_RESPONSE&png=${image}`);
        return res.data;
    }




}
